import { atom } from "recoil";
import { IEmailType } from "../generated/Api";
import { ActiveEmail } from "./ActiveEmailAtom";

export type ICampaignEmailAtom = ActiveEmail & { font: string };

export const CampaignEmailAtom = atom<ICampaignEmailAtom>({
  key: "CampaignEmailAtom",
  default: {
    _id: "",
    subject: "",
    body: "",
    labels: [],
    footerId: "",
    aliasId: "",

    type: IEmailType.Sent,
    font: "Arial",

    isFavorite: false,
    tagQuery: undefined,
    toList: [],
    scheduleTo: undefined,
    contactsSentTo: [],
    showOnArchive: false,
  },
});
